const SELECTORS = {
  grid: '[data-integrations-grid]',
  card: '[data-integrations-card]',
  empty: '[data-integrations-empty]',
  filterButton: '[data-integrations-filter]',
  searchInput: '[data-integrations-search]',
  drawer: '[data-integrations-drawer]',
  drawerClose: '[data-integrations-drawer-close]',
  drawerCategory: '[data-integrations-drawer-category]',
  drawerLogo: '[data-integrations-drawer-logo]',
  drawerName: '[data-integrations-drawer-name]',
  drawerDescription: '[data-integrations-drawer-description]',
  drawerPrimary: '[data-integrations-drawer-primary]',
  drawerSecondary: '[data-integrations-drawer-secondary]',
};

const BODY_CLASS = {
  drawer: 'reveal-integration-drawer',
};

const HIDDEN = 'is-hidden';

const debounce = (fn, wait = 120) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), wait);
  };
};

let hashHandler = null;

const integrations = () => {
  const grid = document.querySelector(SELECTORS.grid);
  if (!grid) return;

  const cards = Array.from(grid.querySelectorAll(SELECTORS.card));
  const empty = grid.querySelector(SELECTORS.empty);
  const filterButtons = Array.from(document.querySelectorAll(SELECTORS.filterButton));
  const searchInput = document.querySelector(SELECTORS.searchInput);
  const drawer = document.querySelector(SELECTORS.drawer);

  const state = {
    category: 'all',
    query: '',
  };

  const applyFilter = () => {
    const q = state.query.trim().toLowerCase();
    let visible = 0;

    cards.forEach((card) => {
      const cat = card.dataset.category || '';
      const name = (card.dataset.name || '').toLowerCase();
      const matchesCategory = state.category === 'all' || cat === state.category;
      const matchesQuery = q === '' || name.includes(q);
      const show = matchesCategory && matchesQuery;
      card.classList.toggle(HIDDEN, !show);
      if (show) visible += 1;
    });

    if (empty) {
      empty.hidden = visible !== 0;
    }
  };

  const bindCategoryFilter = () => {
    filterButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        filterButtons.forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        state.category = btn.dataset.integrationsFilter || 'all';
        applyFilter();
      });
    });
  };

  const bindSearchFilter = () => {
    if (!searchInput) return;
    const onInput = debounce((e) => {
      state.query = e.target.value || '';
      applyFilter();
    }, 100);
    searchInput.addEventListener('input', onInput);
  };

  const populateDrawer = (card) => {
    if (!drawer) return;

    const set = (selector, value) => {
      const el = drawer.querySelector(selector);
      if (el) el.textContent = value || '';
    };

    set(SELECTORS.drawerCategory, card.dataset.categoryName);
    set(SELECTORS.drawerName, card.dataset.name);

    const description = drawer.querySelector(SELECTORS.drawerDescription);
    if (description) description.innerHTML = card.dataset.longDescription || '';

    const logo = drawer.querySelector(SELECTORS.drawerLogo);
    if (logo) {
      logo.src = card.dataset.logo || '';
      logo.alt = card.dataset.logoAlt || card.dataset.name || '';
    }

    const primary = drawer.querySelector(SELECTORS.drawerPrimary);
    if (primary) {
      const url = card.dataset.primaryUrl;
      const label = card.dataset.primaryLabel;
      if (url && label) {
        primary.href = url;
        primary.textContent = label;
        primary.target = card.dataset.primaryTarget || '';
        primary.hidden = false;
      } else {
        primary.hidden = true;
      }
    }

    const secondary = drawer.querySelector(SELECTORS.drawerSecondary);
    if (secondary) {
      const url = card.dataset.secondaryUrl;
      const label = card.dataset.secondaryLabel;
      if (url && label) {
        secondary.href = url;
        secondary.textContent = label;
        secondary.target = card.dataset.secondaryTarget || '';
        secondary.hidden = false;
      } else {
        secondary.hidden = true;
      }
    }
  };

  const openDrawer = (card) => {
    populateDrawer(card);
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add(BODY_CLASS.drawer);
  };

  const closeDrawer = () => {
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove(BODY_CLASS.drawer);

    if (window.location.hash && window.history.replaceState) {
      window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
    }
  };

  const openFromHash = () => {
    const id = window.location.hash.replace(/^#/, '');
    if (!id) return;

    const card = cards.find((c) => c.id === id);
    if (card) openDrawer(card);
  };

  const bindDrawer = () => {
    if (!drawer) return;

    cards.forEach((card) => {
      card.addEventListener('click', (e) => {
        if (e.target.closest('a')) return;
        openDrawer(card);
      });
    });

    drawer.querySelectorAll(SELECTORS.drawerClose).forEach((el) => {
      el.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && document.body.classList.contains(BODY_CLASS.drawer)) {
        closeDrawer();
      }
    });
  };

  bindCategoryFilter();
  bindSearchFilter();
  bindDrawer();

  requestAnimationFrame(openFromHash);

  if (hashHandler) window.removeEventListener('hashchange', hashHandler);
  hashHandler = openFromHash;
  window.addEventListener('hashchange', hashHandler);
};

export default integrations;
